import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { WINDOW } from '@app/shared/utils/window';
import { SetAxesXY } from '@app/state/study/study.actions';
import { Store } from '@ngxs/store';
import { ExploreBarBase } from '../explore-bar-base.component';
import { ExploreBarType } from '../../../../models/filters.model';

@Component({
  selector: 'app-explore-bar-grouping',
  templateUrl: './explore-bar-grouping.component.html',
  styleUrls: ['./explore-bar-grouping.component.scss']
})
export class ExploreBarGroupingComponent extends ExploreBarBase implements OnInit {
  public readonly filterIdPrefix: ExploreBarType = 'grouping';

  constructor(
    protected override store: Store,
    @Inject(WINDOW)
    protected override readonly window: Window,
    protected override readonly cdr: ChangeDetectorRef
  ) {
    super(store, window, cdr);
  }

  protected setAxis() {
    this.store.dispatch(new SetAxesXY({ y: this.selectedFilters || null }));
  }
}
